const prefix = process.env.ASSET_PREFIX || ''

export const quizzBaseURL =
  '/bouger-plus/test-de-niveau-d-activite-physique-et-de-sedentarite-des-ados'

export const deterBaseUrl = '/en-mode-deter'

const routes = {
  homepage: {
    component: '/homepage',
    path: '/',
    name: 'homepage',
    shouldBeOnboarded: false,
  },
  recipes: {
    component: '/recipes',
    path: `${prefix}/recettes`,
    name: 'recipes',
  },
  recipesByTag: {
    component: '/recipesbytag',
    path: `${prefix}/recettes/tag/:tag`,
    name: 'recipesByTag',
  },
  recipe: {
    component: '/recipe',
    path: `${prefix}/recettes/:slug/:side?`,
    name: 'recipe',
  },
  onboarding: {
    component: '/onboarding',
    path: `${prefix}`,
    name: 'onboarding',
    shouldBeOnboarded: false,
  },
  keycloakcheck: {
    component: '/keycloakcheck',
    path: `${prefix}/silent-check-sso`,
    name: 'keycloakcheck',
  },
  // quizz
  quizzLanding: {
    component: '/quizzlanding',
    path: `${prefix}/accueil-quizz`,
    name: 'quizzLanding',
  },
  quizz: {
    component: '/quizz',
    path: `${prefix}/quizz`,
    name: 'quizz',
  },
  quizzResults: {
    component: '/quizzresults',
    path: `${quizzBaseURL}/resultats`,
    name: 'quizzresults',
  },
  quizzResult: {
    component: '/quizzresult',
    path: `${quizzBaseURL}/resultats/:slug`,
    name: 'quizzresult',
  },
  // event
  eventLanding: {
    component: '/eventlanding',
    path: `${deterBaseUrl}`,
    name: 'eventLanding',
  },
  eventDetail: {
    component: '/eventdetail',
    path: `${deterBaseUrl}/:slug`,
    name: 'eventDetail',
  },
  // Onboarding needed routes
  planning: {
    component: '/planning',
    path: `${prefix}/mon-menu`,
    name: 'planning',
    shouldBeOnboarded: true,
  },
  objectives: {
    component: '/objectives',
    path: `${prefix}/mes-objectifs`,
    name: 'objectives',
    shouldBeOnboarded: true,
  },
  preferences: {
    component: '/preferences',
    path: `${prefix}/mes-preferences`,
    name: 'preferences',
    shouldBeOnboarded: true,
  },
  hebdo: {
    component: '/hebdo',
    path: `${prefix}/ma-semaine`,
    name: 'hebdo',
    shouldBeOnboarded: true,
  },
  shoppinglist: {
    component: '/shoppinglist',
    path: `${prefix}/liste-de-courses`,
    name: 'shoppinglist',
    shouldBeOnboarded: true,
  },
  shoppinglistprevious: {
    component: '/shoppinglist',
    path: `${prefix}/liste-de-courses/:id`,
    name: 'shoppinglistprevious',
    shouldBeOnboarded: true,
  },
  switchcourse: {
    component: '/switchcourse',
    path: `${prefix}/changer-plat/:dayNumber/:moment/:id/:side?`,
    name: 'switchcourse',
    shouldBeOnboarded: true,
  },
  planningHistory: {
    component: '/planninghistory',
    path: `${prefix}/mes-menus-precedents`,
    name: 'planninghistory',
    shouldBeOnboarded: true,
  },
  earlierplanning: {
    component: '/earlierplanning',
    path: `${prefix}/mes-menus-precedents/:id`,
    name: 'earlierplanning',
    shouldBeOnboarded: true,
  },
  settings: {
    component: '/settings',
    path: `${prefix}/mes-reglages`,
    name: 'settings',
    shouldBeOnboarded: true,
  },
  offline: {
    component: '/_offline',
    path: `${prefix}/offline`,
    name: 'offline',
  },
}

export default routes
